export const GLOBAL_CONSTANTS = Object.freeze({
  DOWNLOAD_EXCEL: 'Download Excel',
  SEARCH: 'Search',
  FIRST_PAGE: 'First page',
  PREVIOUS_PAGE: 'Previous page',
  NEXT_PAGE: 'Next page',
  LAST_PAGE: 'Last page',
  SAVE: 'Save',
  EDIT: 'Edit',
  DELETE: 'Delete',
  REFRESH: 'Refresh',
  DOWNLOAD: 'Download',
  UPLOAD: 'Upload',
  ADD: 'Add',
  COPY: 'Copy',
  SAVE_CHANGES: 'Save Changes',
  EXPORT: 'Export',
  SAVE_ALL_CHANGES: 'Save All Changes',
  EDIT_ALL_FIELDS: 'Edit All Fields',
  CANCEL_EDIT: 'Cancel Edit',
  SELECT_ROWS_ENABLE_DELETE: 'Select rows to enable delete',
  SELECTED_ROW_S: 'selected row(s)',
  ENTITY_TAN_COL_INFO:
    'Required as Unique ID to map all data. Format: AAAA99999A',
  VENDOR_PAN_COL_INFO:
    'Required for TDS computation. Format: AAAAA9999A. Auto-populates Vendor Status.',
  VENDOR_NAME_COL_INFO:
    'Required in TDS return. No caret character (^) allowed.',
  VENDOR_STATUS_COL_INFO:
    'Auto-populated based on PAN 4th character. C = Company, Others = Other than company',
  RESIDENTIAL_STATUS_COL_INFO:
    'For Form 26Q/27Q bifurcation. Default: R (Resident)',
  TIN_COL_INFO:
    'Tax ID for non-residents. Exactly 20 characters, no caret (^) allowed.',
  OPTING_TAX_REGIME_COL_INFO:
    'Required field in TDS return. Yes/No. In case of "No Input", default value should be "No"',
  ADDRESS_COL_INFO:
    'Required for Vendor Type being "NR". All special characters are allowed except caret character (^)',
  COUNTRY_COL_INFO: 'Required for Vendor Type being "NR"',
  EMAIL_COL_INFO:
    'Required in TDS return. Mandatory if Responsible person\'s email is not provided. Required for Vendor Type being "NR". Both @ and . (dot) should be present in email id. There should be at least 2 alphabets after dot eg: test.test@abc.cc',
  BASIC_EMAIL_VALIDATION_REGEX:
    '^[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]+(\\.[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]+)*@[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]+(\\.[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]+)*\\.[\\x21-\\x2D\\x2F-\\x3F\\x41-\\x5D\\x5F-\\x7E]{2,}$',
  LINKED_USER_COL_INFO:
    'Users linked to multiple email IDs or marked as inactive will not appear in the dropdown. Please raise a JIRA ticket to remove any additional email IDs.',
  PROVISION_ADVANCE_HEADING: 'Provision & Advance knock off',
  PROVISIONS: 'Provisions',
  ADVANCES: 'Advances',
  FULL_SCREEN_TOOLTIP: 'Full Screen',
  EXIT_FULL_SCREEN_TOOLTIP: 'Exit Full Screen',
  DOWNLOAD_ORIGINAL_FILE: 'Download Original File',
  DOWNLOAD_ERROR_FILE: 'Download Error File',
  MAX_TOTAL_SIZE_MB: 50,
  INACTIVITY_LIMIT: 15 * 60 * 1000,
  // Form version constants (PNW-942)
  NEW_FORM_FY_START: '2026-27',
  FORM_TYPE_140: '140',
  FORM_TYPE_144: '144',
  FORM_TYPE_26Q: '26Q',
  FORM_TYPE_27Q: '27Q',
  RETURNS_UNALLOCATED_CHALLAN_WARNING:
    'Few transaction has not yet allocated. Please check on prepare page.',
  COMPLIANCE_MASTER_FILE_DATA_TYPE: 'Compliance Master',
  RESET_SECTION_MASTER_MESSAGE:
    "Clicking on reset button will nullify all the changes done in 'Section Master' restoring the values as per Global Section Master. Do you want to continue?",
  RESET_SECTION_KEYWORD_MESSAGE:
    "Clicking on reset button will nullify all the changes done in 'Section Keyword' restoring the values as per Global Section Keyword. Do you want to continue?",
  // Multi-Territory constants
  MT_DASHBOARD_TITLE: 'Multi-Territory Dashboard',
  MT_DASHBOARD_DESCRIPTION:
    'Manage withholding tax across multiple territories.',
  MT_WELCOME_MESSAGE: 'Welcome to Multi-Territory Module',
  MT_LOADING_TEXT: 'Loading...',
  MT_LOGOUT_LABEL: 'Logout',
  MT_APP_TITLE: 'Navigate Withholding Tax',
  MT_TOGGLE_SIDEBAR: 'Toggle sidebar',
  MT_CLOSE_MENU: 'Close menu',
  MT_NAVIGATE_TO: 'Navigate to',
  MT_REQUIRED_INDICATOR: '*',
  MT_INSIGHT_TITLE: 'Insights',
  MT_INSIGHT_DESCRIPTION: 'View analytics and insights across territories.',
  MT_RETURNS_TITLE: 'Returns',
  MT_RETURNS_DESCRIPTION: 'Manage tax returns across territories.',
  MT_PROVISION_ADVANCE_TITLE: 'Provision & Advance',
  MT_PROVISION_ADVANCE_DESCRIPTION:
    'Manage provisions and advance payments across territories.',
  MT_ADMIN_TITLE: 'Admin',
  MT_ADMIN_DESCRIPTION: 'Manage administrative settings across territories.',
  MT_SELECT_PLACEHOLDER: 'Select an option',
  MT_TAB_NAVIGATION_LABEL: 'Tab navigation',
  MT_ADMIN_ENTITY_TITLE: 'Entity',
  MT_ADMIN_ENTITY_DESCRIPTION: 'Manage entity master data across territories.',
  MT_ADMIN_TIN_TITLE: 'Tax identification number',
  MT_ADMIN_TIN_DESCRIPTION:
    'Manage tax identification numbers across territories.',
  MT_ADMIN_USER_SETUP_TITLE: 'User Setup',
  MT_ADMIN_USER_SETUP_DESCRIPTION: 'Configure user access and permissions.',
  MT_ADMIN_ASSIGN_ENTITY_TITLE: 'Assign entity',
  MT_ADMIN_ASSIGN_ENTITY_DESCRIPTION:
    'Assign entities to users across territories.',
  MT_ADMIN_COMPLIANCE_MASTER_TITLE: 'Compliance Master',
  MT_ADMIN_COMPLIANCE_MASTER_DESCRIPTION: 'Manage compliance master data.',
  MT_ADMIN_CURRENCY_CONVERSATION_TITLE: 'Currency Conversation',
  MT_ADMIN_CURRENCY_CONVERSATION_DESCRIPTION:
    'Manage currency conversion rates.',
  MT_ADMIN_ENTITY_ADD: 'Add',
  MT_ADMIN_ASSIGN_ENTITY_ADD: 'Assign',
  MT_ADMIN_TIN_ADD: 'Add',
  INDIA_COUNTRY: 'India',
  INDIA_COUNTRY_CODE: 'IND',
  INDIA_COUNTRY_CODE_COMPLIANCE:'IN',
  DEFAULT_PAGE_SIZE: 100,
})
